var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{on:{"click":function($event){return _vm.$emit('rowClick', _vm.row)}}},_vm._l((_vm.visibleColumns),function(column){return _c('table-cell',{key:column.id,attrs:{"row":_vm.row,"column":column}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }